<template>
  <ProjectBaseView>
    <div>
      <h1 class="text-h4">Lista de {{ project?.subprojectName }}</h1>
      <div class="subprojects-grid">
        <SubprojectCard
          v-for="subproject in subprojects"
          @click="swichSubproject(subproject._id)"
          :key="subproject._id"
          :title="subproject.name"
          :subtitle="subproject.description"
          :subproject="subproject"
        />
      </div>
    </div>
  </ProjectBaseView>
</template>

<script>
import ProjectBaseView from "./ProjectBaseView.vue";
import SubprojectCard from "@/components/project/dashboard/SubprojectCard.vue";
export default {
  name: "ProjectHomeView",
  components: {
    ProjectBaseView,
    SubprojectCard,
  },
  computed: {
    subprojects() {
      let subprojects = this.$store.state.subprojects || [];

      // Filtrar aquellos en los que el usuario pertenece
      subprojects = subprojects.filter(subproject => 
        subproject.userMembers.includes(this.email) || false
      );
      
      return subprojects;
    },
    project(){
      return this.$store.state.project || null;
    }
  },
  data() {
    return {
      email: localStorage.getItem('email') || null,
    }
  },
  methods: {
    swichSubproject(id) {
      // Crear copias superficiales de los objetos dentro (mantiene los punteros al objeto original)
      let subprojects = [
      ...this.$store.state.subprojects,
      ];

      // Setear en false todos los objetos de la lista
      subprojects.forEach(subproject => {
        subproject.open = false;
      });

      this.$store.commit('set', { att: 'subprojects', value: subprojects });

      // Obtenemos el objeto original
      let subproject = subprojects.find(subproject => subproject._id === id);

      if (subproject) {
        // Lo modificamos
        subproject.open = !subproject.open ?? false;
        this.$store.commit('set', { att: 'subprojects', value: subprojects });
        console.log('subproyectos ->', this.$store.state.subprojects.map(e => e.open ?? false));
      } else {
        console.error(`Subproject with id ${id} not found.`);
      }
    },
  },
};
</script>

<style scoped>
.subprojects-grid{
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 16px;
}
</style>